export enum ExpressionTypes {
    FilterNameOrder = "fno",
    FilterNameOrderByDescending = "fnod",
    FilterRatingOrder = "fro",
    FilterRatingOrderByDescending = "frod",
}